import store from '../../store';
import Errors from '../../Errors';
import ProductRating from '../ProductRating.vue';
import ProductCardMixin from '../../mixins/ProductCardMixin';
import RelatedProducts from './show/RelatedProducts.vue';

export default {
    components: { ProductRating, RelatedProducts },

    mixins: [
        ProductCardMixin,
    ],

    props: ['product', 'reviewCount', 'avgRating', 'until', 'next', 'username'],

    data() {
        return {
            priceTotal: this.product.formatted_price,
            price: this.product.formatted_price,
            activeTab: 'description',
            currentReviewPage: 1,
            fetchingReviews: false,
            reviews: {},
            addingNewReview: false,
            reviewForm: {
                reviewer_name: this.username ? this.username : undefined,
                comment: '',
                rating: '',
            },
            cartItemForm: {
                product_id: this.product.id,
                qty: 1,
                options: {},
            },
            errors: new Errors(),
            buyNow: false,
            maxImageCount: 5,
            selectedImages: [],
            selectedVideo: null,
            formData: new FormData(),
            addedRating: false,
            addedReviewerName: false,
            addedComment: false,
            pendingImages: [],
            pendingVideo: null,
        };
    },

    mounted() {
        if (this.until) {
            const time = this.until.split(':');
            const now = new Date();

            if (this.next) {
                now.setDate(new Date().getDate() + 1);
            }

            now.setHours(time[0], time[1], 0);

            $(this.$el).find('.deals-countdown').countdown({
                until: now,
                format: 'HMS',
                compact: true,
            });
        }
        this.activeFirstOption();
    },

    computed: {
        cartQuantity() {
            return store.state.cart.quantity;
        },

        totalReviews() {
            if (! this.reviews.total) {
                return this.reviewCount;
            }

            return this.reviews.total;
        },

        ratingPercent() {
            return (this.avgRating / 5) * 100;
        },

        emptyReviews() {
            return this.totalReviews === 0;
        },

        totalReviewPage() {
            return Math.ceil(this.reviews.total / 8);
        },
    },

    created() {
        this.fetchReviews();
    },

    methods: {
        updateQuantity(qty) {
            if (qty < 1 || this.exceedsMaxStock(qty)) {
                return;
            }

            if (isNaN(qty)) {
                qty = 1;
            }

            this.cartItemForm.qty = qty;
            this.updatePrice();
        },

        exceedsMaxStock(qty) {
            return this.product.manage_stock && this.product.qty < qty;
        },

        changeReviewPage(page) {
            this.currentReviewPage = page;

            this.fetchReviews();
        },

        updatePrice() {
            this.$nextTick(() => {
                $.ajax({
                    method: 'POST',
                    url: route('products.price.show', { id: this.product.id }),
                    data: { options: this.cartItemForm.options , qty: this.cartItemForm.qty },
                }).then((price) => {
                    this.price = price.formatted;
                    this.priceTotal = price.priceTotal;
                }).catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });
            });
        },

        updateSelectTypeOptionValue(optionId, e) {
            this.$set(this.cartItemForm.options, optionId, $(e.target).val());

            this.errors.clear(`options.${optionId}`);
        },

        updateCheckboxTypeOptionValue(optionId, e) {
            let values = $(e.target)
                .parents('.variant-check')
                .find('input[type="checkbox"]:checked')
                .map((_, el) => {
                    return el.value;
                });

            this.$set(this.cartItemForm.options, optionId, values.get());
        },

        customRadioTypeOptionValueIsActive(optionId, valueId) {
            if (! this.cartItemForm.options.hasOwnProperty(optionId)) {
                return false;
            }

            return this.cartItemForm.options[optionId] === valueId;
        },

        syncCustomRadioTypeOptionValue(optionId, valueId) {
            if (this.customRadioTypeOptionValueIsActive(optionId, valueId)) {
                this.$delete(this.cartItemForm.options, optionId);
            } else {
                this.$set(this.cartItemForm.options, optionId, valueId);

                this.errors.clear(`options.${optionId}`);
            }

            this.updatePrice();
        },

        activeFirstOption() {
            let listOptions = this.product.options;
            listOptions.forEach(option => {
                let optionValue = option.values;
                let option_id_active = optionValue[0].option_id;
                let value_id_active = optionValue[0].id;
                this.syncCustomRadioTypeOptionValue(option_id_active,value_id_active);
            });
        },

        customCheckboxTypeOptionValueIsActive(optionId, valueId) {
            if (! this.cartItemForm.options.hasOwnProperty(optionId)) {
                this.$set(this.cartItemForm.options, optionId, []);

                return false;
            }

            return this.cartItemForm.options[optionId].includes(valueId);
        },

        syncCustomCheckboxTypeOptionValue(optionId, valueId) {
            if (this.customCheckboxTypeOptionValueIsActive(optionId, valueId)) {
                this.cartItemForm.options[optionId].splice(
                    this.cartItemForm.options[optionId].indexOf(valueId),
                    1
                );
            } else {
                this.cartItemForm.options[optionId].push(valueId);

                this.errors.clear(`options.${optionId}`);
            }

            this.updatePrice();
        },

        fetchReviews() {
            this.fetchingReviews = true;

            $.ajax({
                method: 'GET',
                url: route('products.reviews.index', {
                    productId: this.product.id,
                    page: this.currentReviewPage,
                }),
            }).then((reviews) => {
                this.reviews = reviews;
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingReviews = false;
            });
        },

        addNewReview() {
            this.addingNewReview = true;

            if (document.getElementById('g-recaptcha-response')) {
                let reCaptchaResponse = document.getElementById('g-recaptcha-response').value;
                this.reviewForm.g_recaptcha_response = reCaptchaResponse;
            }

            this.formData.append('rating', this.reviewForm.rating);
            this.formData.append('reviewer_name', this.reviewForm.reviewer_name);
            this.formData.append('comment', this.reviewForm.comment);

            for (const file of this.pendingImages) {
                this.formData.append('review_media[]', file);
            }

            if (this.pendingVideo) {
                this.formData.append('review_media[]', this.pendingVideo);
            }

            $.ajax({
                method: 'POST',
                url: route('products.reviews.store', { productId: this.product.id }),
                data: this.formData,
                contentType: false,
                processData: false,
            }).then((review) => {
                this.reviewForm = {
                    rating : '',
                    comment : '',
                    reviewer_name: this.reviewForm.reviewer_name,
                };
                this.selectedImages = [],
                this.pendingImages = [],
                this.selectedVideo = null,
                this.pendingVideo = null,
                this.formData = new FormData();
                this.reviews.total++;
                this.reviews.data.unshift(review);

                $('.captcha-input').prev('img').trigger('click');
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                    this.formData = new FormData();
                } else {
                    this.$notify(xhr.responseJSON.message);
                }
            }).always(() => {
                this.addingNewReview = false;
            });
        },

        addToCart(event) {
            const submitter = event.submitter.id;

            if (submitter === 'buyNow') {
                this.buyNow = true;
            } else {
                this.addingToCart = true;
            }

            $.ajax({
                method: 'POST',
                url: route('cart.items.store', this.cartItemForm),
            }).then((cart) => {
                store.updateCart(cart);

                if (submitter === 'buyNow') {
                    window.location.href = route('cart.index');
                } else  {
                    $('.header-cart').trigger('click');
                }
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                    $('.product-choose-option').trigger('click');
                } else {
                    this.$notify(xhr.responseJSON.message);
                }
            }).always(() => {
                this.addingToCart = false;
                this.buyNow = false;
            });
        },

        handleImageUpload(event) {
            const files = event.target.files;

            if (files.length + this.selectedImages.length > this.maxImageCount) {
                this.$notify(this.$trans('ecommerce::product.review_form.max_image'));
                return;
            }

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.selectedImages.push(e.target.result);
                    this.pendingImages.push(file);
                };
                reader.readAsDataURL(file);
            }
        },

        handleVideoUpload(event) {
            const file = event.target.files[0];

            if (this.selectedVideo) {
                this.selectedVideo = null;
            }

            const maxSizeInBytes = 30 * 1024 * 1024;
            if (file.size > maxSizeInBytes) {
                this.$notify(this.$trans('ecommerce::product.review_form.max_size'));
                return;
            }
            this.pendingVideo = file;
            const reader = new FileReader();

            reader.onload = (e) => {
                this.selectedVideo = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        removeImage(index) {
            this.selectedImages.splice(index, 1);
            this.pendingImages.splice(index, 1);
        },

        removeVideo() {
            this.selectedVideo = null;
            this.pendingVideo = null;
        },

        isVideo(path) {

            return /\.(mp4|webm|ogg)$/i.test(path);
        },

        getVideoTime() {
            setTimeout(() => {
                const videoElement = this.$refs.videoElement;
                let formattedTime = '';
                if (videoElement) {
                    const durationInSeconds = videoElement[0].duration;
                    const minutes = Math.floor(durationInSeconds / 60);
                    const seconds = Math.floor(durationInSeconds % 60);

                    formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
                    $('.slide_video-time').html(formattedTime ? formattedTime : '0:00');
                }
            }, 0);
        },
    },
};
